import { MetricDto } from './metric.dto';

export class Metric {
    readonly id: string;
    readonly batchId: string;
    readonly version: string;
    readonly platform: string;
    readonly type: string;
    readonly at: number;
    readonly route: string;
    readonly duration: number;
    readonly method: string;
    readonly path: string;
    /** Kept nullable — 0 is a real value (network failure or client timeout), not "absent". */
    readonly status: number | null;
    readonly name: string;
    readonly userId: string | null;
    readonly userLabel: string;
    readonly stationCode: string;
    readonly deviceModel: string;
    readonly userAgent: string;
    readonly createdAt: Date;

    constructor(dto: MetricDto) {
        this.id = dto.id;
        this.batchId = dto.batchId;
        this.version = dto.version;
        this.platform = dto.platform;
        this.type = dto.type;
        this.at = dto.at;
        this.route = dto.route;
        this.duration = dto.duration;
        this.method = dto.method ?? '';
        this.path = dto.path ?? '';
        this.status = dto.status;
        this.name = dto.name ?? '';
        this.userId = dto.userId;
        this.userLabel = dto.userLabel ?? '';
        this.stationCode = dto.stationCode ?? '';
        this.deviceModel = dto.deviceModel ?? '';
        this.userAgent = dto.userAgent ?? '';
        this.createdAt = new Date(dto.createdAt);
    }
}
